import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

const Skeleton = styled(MUISkeleton)``;

export const IconSkeleton = styled((props) => (
	<div className={props.className}>
		<Skeleton animation="wave" variant="circular" width={40} height={40} />
		<Skeleton variant="text" height={10} width={80} />
	</div>
))`
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 8px;

  ${mq(Breakpoints.sm)} {
    display: flex;
  }
`;

function Article(props) {
	const renderSkeletons = () => {
		return [...Array(props.count || 1).keys()].map((value) => (
			<Skeleton key={value} variant="rounded" height={50} />
		));
	};

	return (
		<div className={props.className}>
			<IconSkeleton />
			{renderSkeletons()}
		</div>
	);
}

export default styled(Article)`
  ${Skeleton} {
    margin-bottom: 12px;
  }
`;
